import { formatDate } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  OnInit,
  ViewChild,
  Inject,
  OnDestroy,
  TemplateRef,
  signal
} from '@angular/core';
import { Router } from '@angular/router';
import { NoticeIconComponent, NoticeIconList } from '@delon/abc/notice-icon';
import { ACLService } from '@delon/acl';
import { DA_SERVICE_TOKEN, ITokenService } from '@delon/auth';
import { _HttpClient } from '@delon/theme';
//import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Subscription } from 'rxjs';
import { NotificationService } from 'src/app/shared/services/notification.service';

import { FinancialAdvisorService } from '../financial-advisor/financial-advisor.service';
import { RecurringTransactions } from 'src/app/core/constants';

@Component({
  selector: 'header-notify',
  templateUrl: './notify.component.html',
  styleUrls: ['./notify.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HeaderNotifyComponent implements OnInit, OnDestroy {
  @ViewChild('descTpl') private descTpl!: TemplateRef<{
    $implicit: NoticeIconList;
  }>;
  @ViewChild('custInfoUpdateTpl') private custInfoUpdateTpl!: TemplateRef<{
    $implicit: NoticeIconList;
  }>;

  popoverVisible = false;
  private receiveNotification$: Subscription | undefined;
  private receiveBankNotification$: Subscription | undefined;
  private receiveFinancialAdviceMsg$: Subscription | undefined;
  private receiveEinvSubmissionMsg$: Subscription | undefined;
  data = [
    {
      type: 'notify',
      title: 'Notification',
      list: [],
      emptyText: 'No pending notification',
      emptyImage:
        'https://gw.alipayobjects.com/zos/rmsportal/wAhyIChODzsoKIOBHcBk.svg',
      clearText: 'Clear All'
    },
    {
      type: 'message',
      title: 'Message',
      list: [],
      emptyText: 'No Message',
      emptyImage:
        'https://gw.alipayobjects.com/zos/rmsportal/sAuJeJzSKbUmHfBQRzmZ.svg',
      clearText: 'Clear All'
    },
    {
      type: 'task',
      title: 'Task',
      list: [],
      emptyText: 'No pending task!',
      emptyImage:
        'https://gw.alipayobjects.com/zos/rmsportal/HsIsxMZiWKrNUavQUXqx.svg',
      clearText: 'Refresh'
    }
  ];

  count = signal<number>(0);
  loading = false;
  owner = false;
  statusLabels: { [key: string]: string } = {
    todo: 'TO-DO',
    processing: 'In Progress',
    urgent: 'Urgent'
  };
  statusColors: { [key: string]: string } = {
    todo: 'orange',
    processing: 'blue',
    urgent: 'red',
    doing: 'gold'
  };
  @ViewChild(NoticeIconComponent, { static: true })
  noticeComponent!: NoticeIconComponent;
  constructor(
    private router: Router,
    aclService: ACLService,
    private http: _HttpClient,
    @Inject(DA_SERVICE_TOKEN) private tokenService: ITokenService,
    private notifySrv: NotificationService,
    private notificationSrv: NzNotificationService,
    private cdr: ChangeDetectorRef,
    private financialAdvisorSrv: FinancialAdvisorService
  ) {
    this.owner = aclService.canAbility('user.owner');

    this.receiveBankNotification$ = this.notifySrv
      .bankNotifications()
      .subscribe(res => {
        const msg = typeof res === 'string' ? JSON.parse(res) : res;
        const title = msg?.title ?? msg?.Title ?? 'Notification';
        const description = msg?.description ?? msg?.Description ?? '';
        this.notificationSrv.success(title, description);
        this.loadData();
      });

    this.receiveFinancialAdviceMsg$ = this.notifySrv
      .getFinancialAdviceObservable()
      .subscribe(res => {
        // const msg = JSON.parse(res);
        // this.notificationSrv.success(msg.title, msg.description);
        this.loadData();
      });

    this.receiveEinvSubmissionMsg$ = this.notifySrv
      .getEInvSubmissionObservable()
      .subscribe(res => {
        this.loadData();
      });

    // this.receiveNotification$ = this.notifySrv
    //   .receiveMessage()
    //   .subscribe(res => {
    //     //const msg = JSON.parse(res.data);
    //     this.notificationSrv.success(res.title, res.description);
    //   });
    //this.service.auth.tokenChanged.on(() => this.loadData());
  }
  ngOnDestroy(): void {
    if (this.receiveBankNotification$)
      this.receiveBankNotification$.unsubscribe();
    if (this.receiveFinancialAdviceMsg$)
      this.receiveFinancialAdviceMsg$.unsubscribe();
    if (this.receiveEinvSubmissionMsg$)
      this.receiveEinvSubmissionMsg$.unsubscribe();
    if (this.receiveNotification$) this.receiveNotification$.unsubscribe();
  }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.data.forEach(i => (i.list = []));
    this.count.set(0);
    this.cdr.detectChanges();
    const token = this.tokenService.get();
    if (!token?.token) return;
    this.http.get('api/Notifications').subscribe((res1: any[]) => {
      const items = res1.map((row: any) => {
        const notifyItem = {
          type: row.type,
          title: row.title,
          description: this.descTpl,
          content: row.description,
          id: row.notificationId,
          read: row.read,
          datetime: row.createdAt,
          category: row.category,
          data: row.json ? JSON.parse(row.json) : {}
        };
        if (notifyItem.category === 'CUST_UPDATE') {
          notifyItem.description = this.custInfoUpdateTpl;
        }
        return notifyItem;
      });
      this.fillData(items);
      this.count.set(res1.length);
      this.cdr.detectChanges();
    });
  }

  clearNum() {
    this.count.set(0);
  }

  clear(type: string) {
    if (type === 'Notification') type = 'notify';
    this.http.post('api/Notifications/ClearAll', { type }).subscribe(() => {
      this.loadData();
    });
  }

  select(res: any) {
    const item = res.item;
    if (item.type === 'notify') {
      switch (item.category) {
        case 'financial-advice':
          this.toggleAdvisor();
          break;
        case 'einv-submission':
        case 'einv-reject':
          this.navigateToTransaction(item);
          break;
        case 'recurring-transaction':
          this.navigateToRecurringTransaction(item);
          break;
        default:
          this.http.post('api/Notifications/MarkRead', { id: item.id });
          break;
      }
    } else if (item.type === 'task') {
      if (item.category === 'update-customer-tax-info') {
        this.router.navigate(['/ar/customer/update-tax-info']);
        return;
      }
      if (item.category === 'update-supplier-tax-info') {
        this.router.navigate(['/ap/supplier/update-supp-tax-info']);
        return;
      }
      switch (item.id) {
        case 'company_profile': {
          this.router.navigate(['company/profile']);
          break;
        }
        default: {
          if (item.url) this.router.navigate([item.url]);
          break;
        }
      }
    } else if (item.type === 'setting') {
      switch (item.category) {
        case 'financial-advice-setting': {
          this.router.navigate(['account/settings/notification']);
          break;
        }
        default: {
          if (item.url) this.router.navigate([item.url]);
          break;
        }
      }
    }
    this.cdr.detectChanges();
  }

  private fillData(items: NoticeIconList[]) {
    items.forEach(item => {
      const newItem: any = { ...item };
      if (newItem.category === 'UOB' || newItem.category === 'uob') {
        newItem.avatar = './assets/uob/uob.png';
      }

      if (newItem.datetime) {
        // newItem.datetime = formatDistanceToNow(newItem.datetime as Date, {
        //   locale: undefined
        // });
        newItem.datetime = formatDate(
          newItem.datetime as Date,
          'MMM dd, yyyy h:mm:ss a',
          'en-US'
        );
      } else if (newItem.createdAt) {
        newItem.datetime = formatDate(
          newItem.createdAt,
          'MMM dd, yyyy HH:mm:ss',
          'en-US'
        );
      }

      if (newItem.status) {
        newItem.extra = this.statusLabels[newItem.status];

        newItem['color'] = this.statusColors[newItem.status];
      }
      const group: any = this.data.find(w => w.type === newItem.type);
      if (group) group.list.push(newItem);
    });
    this.cdr.detectChanges();
  }

  navigateToTransaction(item: any) {
    this.popoverVisible = false;
    this.cdr.detectChanges();

    switch (item.data.docType) {
      case 'SINV': {
        this.router.navigate([`/sale/inv/detail/${item.data.docId}`]);
        break;
      }
      case 'SDN': {
        this.router.navigate([`/sale/dn/detail/${item.data.docId}`]);
        break;
      }
      case 'CS': {
        this.router.navigate([`/sale/cs/detail/${item.data.docId}`]);
        break;
      }
      default:
        break;
    }
  }

  navigateToRecurringTransaction(item: any) {
    this.popoverVisible = false;
    this.cdr.detectChanges();
    var transactionType = RecurringTransactions.find(
      p => p.value == item.data.DocType
    );
    if (transactionType) {
      this.router.navigate(
        [
          `/${transactionType.group.toLowerCase()}/${transactionType.code.toLowerCase()}/detail/0`
        ],
        { queryParams: { recurringId: item.data.Id } }
      );
    }
  }

  toggleAdvisor() {
    this.financialAdvisorSrv.showModel();
  }
}
